import type { User } from '@repo-level/core-front';
import { addPlayerGroups } from 'api/auth';
import { AB_TESTS_PREFIX } from '../constants';
import { ABTestingStore } from './abTestStorage';
import { isUserAppropriateForTest } from './isUserAppropriateForTest';

export const syncUserGroupAndLSAbVersions = async (user: User) => {
  if (!user?.statuses) return;

  // sync user groups and LocalStorage
  const userVersions = user.statuses
    .filter(({ id }) => id.startsWith(AB_TESTS_PREFIX))
    .map(({ id }) => id);

  userVersions.forEach((version) => {
    const [experiment] = version.split(':');

    ABTestingStore(experiment).replace({ name: version });
  });

  // sync LocalStorage and user groups
  const localStorageKeys = Object.keys(localStorage);
  const localStorageVersionsKeys = localStorageKeys.filter((key) =>
    key.startsWith(AB_TESTS_PREFIX)
  );

  const localStorageVersions = localStorageVersionsKeys.flatMap((key) => {
    const name = ABTestingStore(key).get()?.name;
    return name &&
      !userVersions.includes(name) &&
      isUserAppropriateForTest(name, user.createdAt)
      ? [name]
      : [];
  });

  if (!localStorageVersions.length) return;

  await addPlayerGroups(localStorageVersions);

  return true;
};
